<div class="modal-header" appCustomAutofocus>
    <h3 class="modal-title">
        {{mode == 'H' ? 'Action Item Workflow' : 'Checklist Workflow'}}
    </h3>
</div>
<div class="modal-body" style="overflow-x: auto;" id="modal_size">
    <div class="col-md-12">
        <div class="alert" *ngIf="alert != null" [ngClass]="{'alert-success' : alert.type == 'success', 'alert-default' : alert.type == 'default', 'alert-danger': alert.type == 'danger' }" role="alert">
            {{alert.msg}}
            <button type="button" class="close" (click)="closeAlert()">
                <i class="modus-icons">close</i>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <table class="table">
                <thead>
                    <tr>
                        <th>
                            <button type="button" class="button-link" (click)="setRowSort('UserFullName')">
                                <strong>Reviewer</strong>
                                <span style="margin-left:5px;" *ngIf="rowOrder == 'UserFullName' && !reverse"><i class="modus-icons align-bottom">chevron_up_thick</i></span>
                                <span style="margin-left:5px;" *ngIf="rowOrder == 'UserFullName' && reverse"><i class="modus-icons align-bottom">chevron_down_thick</i></span>
                            </button>
                        </th>
                        <th>
                            <button type="button" class="button-link" (click)="setRowSort('ReviewerSource')">
                                <strong>Source</strong>
                                <span style="margin-left:5px;" *ngIf="rowOrder == 'ReviewerSource' && !reverse"><i class="modus-icons align-bottom">chevron_up_thick</i></span>
                                <span style="margin-left:5px;" *ngIf="rowOrder == 'ReviewerSource' && reverse"><i class="modus-icons align-bottom">chevron_down_thick</i></span>
                            </button>
                        </th>
                        <th *ngIf="!isSubmitted"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let reviewer of reviewers">
                        <td>{{reviewer.UserFullName}}</td>
                        <td>{{reviewer.ReviewerSource}}</td>
                        <td *ngIf="!isSubmitted">
                            <a class="button-link" [href]="" style="cursor: pointer;"
                               *ngIf="!reviewer.ConfirmDelete"
                               (click)="removeReviewer(reviewer)">
                                Remove
                            </a>
                            <a class="button-link" [href]="" style="cursor: pointer;" *ngIf="reviewer.ConfirmDelete"
                               (click)="confirmRemove(reviewer)">
                                Confirm Delete
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="row" *ngIf="!isSubmitted">
        <div class="col-lg-6 col-md-12">
            <label><strong>Add an individual:</strong></label>
            <div class="input-group" style="flex-wrap: nowrap;">
                <ng-select [items]="employee$ | async"
                           [hideSelected]="true"
                           [multiple]="false"
                           [typeahead]="employeeInput$"
                           [virtualScroll]="true"
                           bindLabel="FullName"
                           bindValue="KeyID"
                           [loading]="employeeLoading"
                           typeToSearchText="Type to search..."
                           [(ngModel)]="formData.selectedEmployee"
                           dropdownPosition="bottom"
                           style="min-width: 75%;">
                </ng-select>
                <span class="input-group-append">
                    <button class="btn btn-primary" type="button" (click)="addReviewer()"><span><i class="modus-icons align-bottom" style="margin-left: -15px;">add</i></span> Add</button>
                </span>
            </div>
        </div>
    </div>

    <div class="card border" [style.width.px]="465" style="margin-top:25px;">
        <div class="card-header bg-light">
            Please sign in the box below when you finish your {{mode == 'H' ? 'action item' : 'checklist'}}.
        </div>
        <div class="card-body" [style.width.px]="465" style="background-color:#d4d4d4;border:1px solid black;border-radius:5px;">
            <div class="alert alert-info" style="margin:10px;" *ngIf="showClickMsg">Press "Clear" before generating your signature image.</div>
            <div class="m-signature-pad">
                <div class="m-signature-pad--body" [ngClass]="{signaturepad: redBorder == true}"
                     *ngIf="checklistDetails?.SignedOn == null && !typeSign">
                    <ngx-signaturepad [width]="410" [height]="150" #signaturePad></ngx-signaturepad>
                </div>
                <div *ngIf="submitSignImg != null" style="background-color:white;border:1px solid black">
                    <img [src]="submitSignImg" *ngIf="checklistDetails?.SignedOn == null && typeSign" [style.max-width.px]="panelWidth - 50" />
                </div>
                <div class="m-signature-pad--footer">
                    <div style="text-align: center;font-size: 12px;">Sign above</div>
                    <button type="button" class="btn btn-outline-dark" (click)="clear()">Clear</button>
                    <button type="button" class="btn btn-outline-dark" (click)="getTypeSign('full')" *ngIf="enableCheckboxSign && !hideClick">Generate Signature</button>
                    <div class="alert alert-warning" style="margin:10px;">By signing above, I agree that the signature and initials will be the electronic representation of my signature and initials for all purposes when I (or my agent) use them on documents, including legally binding contracts - just the same as a pen-and-paper signature or initial.</div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <div class="col-lg-12" style="padding:0px;">
        <button type="button" class="btn btn-primary float-left mb-1" *ngIf="!submitMode"
                (click)="realNotifyReviewers()" [disabled]="refreshing || notifying || submitting || !canNotify || reviewers.length < 1">
            Notify Reviewers
        </button>
        <button type="button" class="btn btn-warning float-left mb-1" *ngIf="!confirmRefresh && !isSubmitted" [disabled]="refreshing || notifying || submitting"
                (click)="requestRefresh()">
            Reset Workflow
        </button>
        <button type="button" class="btn btn-success float-left mb-1" *ngIf="confirmRefresh  && !isSubmitted" [disabled]="refreshing || notifying || submitting || reviewers.length < 1"
                (click)="initializeChecklistReviewers()">
            Confirm Refresh
        </button>
        <button type="button" class="btn btn-primary float-right mb-1"
                *ngIf="submitMode" (click)="submitClicked()" [disabled]="refreshing || notifying || submitting || reviewers.length < 1">
            Submit
        </button>
        <button type="button" class="btn btn-outline-dark float-right mb-1" (click)="closeClicked()" [disabled]="refreshing || notifying || submitting">Close</button>
    </div>
</div>